import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  CircularProgress,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {
  APPURL,
  BASEURL,
  emailVerified,
  TOKEN_NOT_FOUND,
  verificationFailed,
} from "../constant/constant";
import { apiCall } from "../API/apiCall";
import { toast } from "react-toastify";

const EmailVerified = () => {
  const [loading, setLoading] = useState(true);
  const [isVerified, setIsVerified] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const verifyEmail = async () => {
      setLoading(true);
      setError(null);

      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("token");

      if (!token) {
        setError(TOKEN_NOT_FOUND);
        setLoading(false);
        return;
      }

      try {
        const response = await apiCall({
          url: `${BASEURL}/verifyEmail/${token}`,
          method: "POST",
        });

        if (response.status === "success") {
          setIsVerified(true);
        } else {
          if (response.Error === "Account already activated") {
            setTimeout(() => {
              window.location.href = APPURL;
            }, 2000);
          }
          setError(response.message || verificationFailed);
          setIsVerified(false);
        }
      } catch (err) {
        console.error("API call failed:", err);
        setError(
          "Failed to connect to the verification service. Please try again later."
        );
      } finally {
        setLoading(false);
      }
    };

    verifyEmail();
  }, []);

  const handleContinue = () => {
    window.location.href = APPURL;
  };

  const renderContent = () => {
    if (loading) {
      return (
        <>
          <CircularProgress sx={{ mb: 2 }} />
          <Typography variant="h5" component="h1" gutterBottom>
            Verifying your email...
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Please wait while we confirm your email address.
          </Typography>
        </>
      );
    }

    if (error) {
      return (
        <>
          <ErrorOutlineIcon color="error" sx={{ fontSize: 80, mb: 2 }} />
          <Typography variant="h4" component="h1" gutterBottom color="error">
            Verification Failed
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            {error}
          </Typography>
        </>
      );
    }

    if (isVerified) {
      return (
        <>
          <CheckCircleOutlineIcon
            color="success"
            sx={{ fontSize: 80, mb: 2 }}
          />
          <Typography variant="h4" component="h1" gutterBottom>
            Email Verified Successfully!
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Thank you for verifying your email address. Your request has been
            forwarded to our admin team for approval. You will receive a
            confirmation email with your credentials once approved.
          </Typography>
          {/* <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleContinue}
            sx={{ mt: 2 }}
          >
            Continue to My Account
          </Button> */}
        </>
      );
    }

    return (
      <Typography variant="body1" color="text.secondary">
        An unexpected error occurred.
      </Typography>
    );
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          mt: 8,
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "white",
          borderRadius: 2,
          boxShadow: 3,
          textAlign: "center",
        }}
      >
        {renderContent()}
      </Box>
    </Container>
  );
};

export default EmailVerified;
